import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
    ApiThesaurusConcept,
    BaseNestedFieldDefinition,
    DialogConfig,
    ThesaurusApiTranslation
} from '@stylehaven/components';

interface LangLabels {
    Lang: string;
    Labels: string[];
}
@Component({
    selector: 'med-thesaurus-concept-dialog',
    templateUrl: './thesaurus-concept-dialog.component.html',
    styleUrls: ['./thesaurus-concept-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThesaurusConceptDialogComponent {
    readonly thesaurusConcept: ApiThesaurusConcept;
    private thesaurusFieldDef: BaseNestedFieldDefinition;
    alternativeLabels: LangLabels[];

    constructor(dialogConfig: DialogConfig<{ concept: ApiThesaurusConcept; fieldDef: BaseNestedFieldDefinition }>) {
        if (dialogConfig.data) {
            this.thesaurusConcept = dialogConfig.data.concept;
            this.thesaurusFieldDef = dialogConfig.data.fieldDef;
            this.setAlternativeLabels();
        }
    }

    get preferredLabels(): ThesaurusApiTranslation[] {
        return [...this.thesaurusConcept.PreferredLabels]
            .filter(label => this.isLangAvailable(label.Lang))
            .sort(this.thesaurusTranslationSorter);
    }

    private setAlternativeLabels(): void {
        const uniqueLanguages: string[] = [
            ...new Set(this.thesaurusConcept.AlternativeLabels.map(langLabel => langLabel.Lang))
        ];

        const langLabels: LangLabels[] = uniqueLanguages
            .map(lang => ({
                Lang: lang,
                Labels: this.thesaurusConcept.AlternativeLabels.filter(langLabel => langLabel.Lang === lang).map(
                    langLabel => langLabel.Label
                )
            }))
            .filter(label => this.isLangAvailable(label.Lang))
            .sort(this.thesaurusTranslationSorter);

        this.alternativeLabels = langLabels;
    }

    private thesaurusTranslationSorter(
        a: ThesaurusApiTranslation | LangLabels,
        b: ThesaurusApiTranslation | LangLabels
    ): number {
        return a.Lang.localeCompare(b.Lang);
    }

    private isLangAvailable(lang: string): boolean {
        return !!this.thesaurusFieldDef.Children?.find(child => child.Lang === lang);
    }
}
